<div class="p-fluid">
    <div class="grid">
      <div class="col-12">
        <div class="card card-w-title">
          <h1>{{ 'ข้อมูล เครื่องราชอิสริยาภรณ์' | translate }}</h1>
          <hr />
          <div class="card">
            <div class="grid justify-content-between">
              <div class="col-fixed">
                <h1>ข้อมูล เครื่องราชอิสริยาภรณ์</h1>
              </div>
              <div class="col"></div>
              <div class="col-fixed">
                <button
                  *ngIf="isEditable"
                  pButton
                  type="button"
                  label="{{ 'add_data' | translate }}"
                  (click)="showCreateInsigniaDialog()"
                ></button>
              </div>
            </div>
            <p-table [autoLayout]="true" [tableStyle]="{'width': '100%', 'min-width': '640px' }" breakpoint="0" [value]="insigniaList">
              <ng-template pTemplate="header">
                <tr>
                  <th>ชื่อเครื่องราช</th>
                  <th>ปีที่ได้รับ</th>
                  <th>หมายเหตุ</th>
                  <th *ngIf="isEditable" style="width: 100px">Action</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rowData>
                <tr>
                  <td>{{ rowData.insigniaName }}</td>
                  <td>{{ rowData.year }}</td>
                  <td>{{ rowData.remark }}</td>
                  <td *ngIf="isEditable">
                    <div class="grid justify-content-around icon-action">
                      <div class="col-fixed">
                        <i
                          class="fa fa-pencil-alt"
                          (click)="UpdateInsigniaDialog(rowData.employeeInsigniaId)"
                        ></i>
                      </div>
                      <div class="col-fixed">
                        <i class="fa fa-trash" (click)="DeleteInsigniaDialog(rowData.employeeInsigniaId)"></i>
                      </div>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="8" class="emptymessage">ไม่พบข้อมูล</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>
  </div>
  